import { render } from "./TemplateView.vue?vue&type=template&id=00204a2a&scoped=true"
import script from "./TemplateView.vue?vue&type=script&lang=js"
export * from "./TemplateView.vue?vue&type=script&lang=js"

import "./TemplateView.vue?vue&type=style&index=0&id=00204a2a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\DigitalDirectory-Application\\projects\\template-view\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00204a2a"]])

export default __exports__